export const subTitleStyle = {
	fontFamily: "Nunito-ExtraBold",
	fontSize: "40px",
	//color: "#A4ACFD",
	letterSpacing: "1px",
	textAlign: "center",
	lineHeight: "50px",
}

export const textStyle = {
	fontFamily: "Nunito-SemiBold",
	fontSize: "20px",
	color: "#171717",
	letterSpacing: "0.4px",
	textAlign: "center",
	lineHeight: "30px"
}

export const nameStyle = {
	fontFamily: "Nunito-ExtraBold",
	fontSize: "40px",
	color: "#171717",
	letterSpacing: "1px",
	textAlign: "center",
	lineHeight: "50px"
}